export default "__VITE_ASSET__MX8h7DX6__"